export default "__VITE_ASSET__BzzxT3pu__"